import axios from "axios";

export const getNews = async () => {
  const res = await axios.get("https://alnabaatech.com.ly/api/news");
  return res.data.data;
};